<template>
    <div class="row">
        <!-- main title -->
        <div class="col-12">
            <div class="main__title">
                <h2>افزودن ایتم دیزاین</h2>
            </div>
        </div>
        <!-- end main title -->



        <div class="col-12">
            <form action="#" class="form">
                <div class="row">

                    <div class="col-12 col-md-7 form__content">
                        <div class="row">
                            <div class="col-12">
                                <div class="form__group">
                                    <input v-model="name" type="text" class="form__input" placeholder="عنوان">
                                </div>
                            </div>


                            <div class="col-12 col-lg-6" v-if="!first_data">
                                <div class="form__group">
                                    <treeselect
                                                v-model:modelValue="selected_genre"
                                                :normalizer="normalizer_genres"
                                                :options="genres"/>

                                </div>
                            </div>
                            <div class="col-12 col-lg-6" v-if="!first_data">
                                <div class="form__group">
                                    <treeselect v-model:modelValue="selected_category"
                                                :multiple="false"
                                                :normalizer="normalizer_cats"
                                                :options="categories"/>

                                </div>
                            </div>


                        </div>
                    </div>

                    <div class="col-12">
                        <div class="row">

                            <div class="col-12">
                                <button v-if="status_form==0" @click="insert_data()" type="button" class="form__btn">ثبت</button>
                                <button v-if="status_form!=0" @click="insert_data()" type="button" class="form__btn">ویرایش</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">

                        <div class="row">
                            <!-- main title -->
                            <!-- end main title -->

                            <!-- users -->
                            <div class="col-12">
                                <Datatable
                                        :items="items"
                                        :fields="fields"
                                        style="overflow: auto"
                                        :items-per-page="20"
                                        hover
                                        height="300px"
                                        border
                                        striped
                                        sorter
                                        column-filter
                                        pagination
                                >
                                    <template #row="{item,index}">
                                        <td>
                                            <div class="main__table-text">{{index+1}}</div>
                                        </td>
                                    </template>
                                    <template #operation="{item}">
                                        <td>
                                            <div class="main__table-btns">
                                                <!--                                    <div datas="#modal-status" class="main__table-btn main__table-btn&#45;&#45;banned open-modal">-->
                                                <!--                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12,13a1.49,1.49,0,0,0-1,2.61V17a1,1,0,0,0,2,0V15.61A1.49,1.49,0,0,0,12,13Zm5-4V7A5,5,0,0,0,7,7V9a3,3,0,0,0-3,3v7a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V12A3,3,0,0,0,17,9ZM9,7a3,3,0,0,1,6,0V9H9Zm9,12a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H17a1,1,0,0,1,1,1Z"/></svg>-->
                                                <!--                                    </div>-->
                                                <!--                                    <div datas="#" class="main__table-btn main__table-btn&#45;&#45;view">-->
                                                <!--                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.92,11.6C19.9,6.91,16.1,4,12,4S4.1,6.91,2.08,11.6a1,1,0,0,0,0,.8C4.1,17.09,7.9,20,12,20s7.9-2.91,9.92-7.6A1,1,0,0,0,21.92,11.6ZM12,18c-3.17,0-6.17-2.29-7.9-6C5.83,8.29,8.83,6,12,6s6.17,2.29,7.9,6C18.17,15.71,15.17,18,12,18ZM12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"/></svg>-->
                                                <!--                                    </div>-->
                                                <div @click="edit_item(item)" datas="#"
                                                     class="main__table-btn main__table-btn--edit">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                        <path d="M22,7.24a1,1,0,0,0-.29-.71L17.47,2.29A1,1,0,0,0,16.76,2a1,1,0,0,0-.71.29L13.22,5.12h0L2.29,16.05a1,1,0,0,0-.29.71V21a1,1,0,0,0,1,1H7.24A1,1,0,0,0,8,21.71L18.87,10.78h0L21.71,8a1.19,1.19,0,0,0,.22-.33,1,1,0,0,0,0-.24.7.7,0,0,0,0-.14ZM6.83,20H4V17.17l9.93-9.93,2.83,2.83ZM18.17,8.66,15.34,5.83l1.42-1.41,2.82,2.82Z"/>
                                                    </svg>
                                                </div>
                                                <div @click="delete_item(item)" datas="#modal-delete"
                                                     class="main__table-btn main__table-btn--delete open-modal">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                        <path d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"/>
                                                    </svg>
                                                </div>
                                                <div @click="up_down_order(item,true)" datas="#modal-delete"
                                                     class="main__table-btn main__table-btn--delete open-modal">
                                                   ^
                                                </div>
                                                <div @click="up_down_order(item,false)" datas="#modal-delete"
                                                     class="main__table-btn main__table-btn--delete open-modal">
                                                   v
                                                </div>

                                            </div>
                                        </td>
                                    </template>
                                </Datatable>

                            </div>


                        </div>
                    </div>
                </div>
            </form>
        </div>
        <!-- end form -->
    </div>
</template>

<script>
    import axios from "axios";
    // import {bus} from '../main';
    import ImageSelector from "@/views/CustomComponent/ImageSelector";
    // import the styles
    import 'vue3-treeselect/dist/vue3-treeselect.css'
    import Treeselect from 'vue3-treeselect/dist/vue3-treeselect.common'

    import Datatable from "@/views/customTable/Datatable";

    export default {
        name: 'HelloWorld',
        data() {
            return {
                items: [],
                fields: [
                    {key: 'row', label: 'ردیف'},
                    {key: 'name', label: 'نام'},
                    {key: 'category', label: 'دسته بندی'},
                    {key: 'genre', label: 'ژانر'},

                    {key: 'operation', label: 'عملیات'}
                ],
                theme_mode_parent: '',
                mybutton: '',
                home_data: {slides: []},
                file_preview: '',
                file: null,
                first_data: false,
                file_preview_cover: '',
                file_cover: null,
                selected_country: [],
                countries: [],
                selected_genre: null,
                genres: [],
                selected_category: null,
                categories: [],
                name: '',
                summary: '',
                release_year: '',
                duration: '',
                imdb: '',
                price: '',
                link: '',
                old_price: '0',
                type: 1,
                status: 0,
                pay_type: 1,
                status_form: 0,
                normalizer_genres(node) {
                    return {
                        id: node.id,
                        label: node.name,
                    }
                },
                normalizer_cats(node) {
                    return {
                        id: node.id,
                        label: node.name,
                    }
                },
            }
        },
        components: {
            ImageSelector,
            Datatable,
            Treeselect
        },
        mounted() {
            this.get_genres();
            this.get_categories();

                this.get_data();
        },
        methods: {
            edit_item(item) {
                this.first_data = true
                this.name = item.name;
                this.selected_category = item.category_id;
                this.selected_genre = item.genre_id;
                var self = this;
                setTimeout(function () {

                    self.first_data = false

                },1000)

            },
            delete_item(item) {

                var self = this;


                var formData = new FormData();
formData.append("id",item.id);
                this.axios.post('delete_design', formData, {}).then(function (response) {
                    self.get_data();
                }).catch(function (error) {
                    console.log(error);
                });


            },
            get_data() {

                var self = this;


                var formData = new FormData();
                this.axios.post('get_design', formData, {}).then(function (response) {

                    var content_data = response.data;
                   self.items=content_data;
                }).catch(function (error) {
                    console.log(error);
                });


            },
            get_genres() {

                var self = this;

                var formData = new FormData();

                this.axios.post('get_genres', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;

                    self.genres = content_data

                }).catch(function (error) {
                    console.log(error);
                });


            },
            get_categories() {

                var self = this;

                var formData = new FormData();

                this.axios.post('get_all_categories', formData, {}).then(function (response) {

                    var content_data = response.data.data;

                    // items = content_cats.orders;
                    content_data.forEach(function (val) {
                        val.children.forEach(function (val2) {
                            val2.value = val2.id;
                            val2.label = val2.name
                        })
                    })
                    self.categories = content_data

                }).catch(function (error) {
                    console.log(error);
                });


            },
            insert_data() {

                var self = this;

                var formData = new FormData();
                var url = ""
                if (this.status_form == 0) {
                    url = "add_design";
                } else {
                    url = "update_design"
                    formData.append("id", this.status_form)
                    formData.append("order", this.items.filter(x=>x.id ==this.status_form)[0].order)
                }
                formData.append("name", this.name)

                formData.append("genre_id", this.selected_genre)
                formData.append("category_id", this.selected_category)


                this.axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data.data;
                    self.get_data()
                    // items = content_cats.orders;

                    self.$toast.success('ثبت با موفقیت انجام شد');

                }).catch(function (error) {
                    console.log(error);
                    self.$toast.error('خطا در ثبت اطلاعات');

                });


            },
            up_down_order(item,up) {

                var self = this;

                var formData = new FormData();
                var url = ""

                    url = "update_design"
                    formData.append("id", item.id)
                if(up){
                    formData.append("order", parseInt(item.order)-1)

                }else{
                    formData.append("order", parseInt(item.order) +1)

                }

                formData.append("name", item.name)

                formData.append("genre_id", item.genre_id)
                formData.append("category_id", item.category_id)


                this.axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data.data;
                    self.get_data()
                    // items = content_cats.orders;


                }).catch(function (error) {
                    console.log(error);
                });


            },
        }
    }
</script>

